import { ACCOUNT_ROLE_IDS } from '../constants';

import type { Account } from '@rewardopl/types';

export function isLoggedIn(user: Account | null): user is Account {
  return Boolean(user);
}

export function isLoggedOut(user: Account | null): user is null {
  return !isLoggedIn(user);
}

export function isGlobalAccount(user: Account | null): user is Account {
  return isLoggedIn(user) && !user.business_id;
}

export function isRewardoAdmin(user: Account | null): boolean {
  return isLoggedIn(user) && user.account_role_id === ACCOUNT_ROLE_IDS.REWARDO_ADMIN;
}
